/**
 * Shared color configuration for tags, categories, and other UI elements.
 * Provides both color names and their corresponding hex values.
 */
export const TAG_COLORS = [
    'indigo',
    'purple',
    'violet',
    'fuchsia',
    'pink',
    'rose',
    'red',
    'orange',
    'amber',
    'lime',
    'green',
    'emerald',
    'teal',
    'blue',
];
/**
 * Maps color names to their hex values (using Tailwind 500 shade equivalents)
 */
export const TAG_COLOR_HEX = {
    amber: '#f59e0b',
    blue: '#3b82f6',
    emerald: '#10b981',
    fuchsia: '#d946ef',
    green: '#22c55e',
    indigo: '#6366f1',
    lime: '#84cc16',
    orange: '#f97316',
    pink: '#ec4899',
    purple: '#a855f7',
    red: '#ef4444',
    rose: '#f43f5e',
    teal: '#14b8a6',
    violet: '#8b5cf6',
};
/**
 * Default hex color values for tag selection (subset of all colors)
 * These are the colors shown in the tag color picker
 */
export const DEFAULT_TAG_COLOR_HEX_VALUES = [
    TAG_COLOR_HEX.blue,
    TAG_COLOR_HEX.purple,
    TAG_COLOR_HEX.pink,
    TAG_COLOR_HEX.amber,
    TAG_COLOR_HEX.emerald,
    TAG_COLOR_HEX.teal,
    TAG_COLOR_HEX.indigo,
    TAG_COLOR_HEX.red,
];
